<script lang="ts">
  const artikel = [
    {
      slug: 'passwort-leck-pruefen',
      titel: 'Passwörter im Datenleck: So prüfst du in 5 Minuten, ob du betroffen bist',
      beschreibung:
        'Milliarden Zugangsdaten kursieren im Netz. So prüfst du kostenlos, ob du betroffen bist, und sicherst deine Konten in der richtigen Reihenfolge ab.',
    },
    {
      slug: 'digitaler-nachlass',
      titel: 'Digitaler Nachlass regeln: Was deine Familie im Ernstfall wirklich braucht',
      beschreibung:
        'Rund 100 Milliarden Euro werden in Deutschland jedes Jahr vererbt – oft ohne Zugang zu Konten und Unterlagen. So regelst du das in einem Nachmittag.',
    },
  ];
</script>

<section id="ratgeber" class="abschnitt">
  <div class="breite">
    <div class="mitte">
      <h2>Aus unserem Ratgeber</h2>
      <p class="vorspann">Verständliche Anleitungen rund um Passwörter und digitale Vorsorge.</p>
    </div>

    <div class="karten-grid">
      {#each artikel as a}
        <a class="karte ratgeber-karte" href="/ratgeber/{a.slug}/">
          <h3>{a.titel}</h3>
          <p class="leise">{a.beschreibung}</p>
          <span class="weiter">Weiterlesen →</span>
        </a>
      {/each}
    </div>

    <p class="mitte leise ratgeber-mehr"><a href="/ratgeber/">Alle Ratgeber-Artikel ansehen →</a></p>
  </div>
</section>

<style>
  .ratgeber-karte {
    display: block;
    text-decoration: none;
    color: inherit;
  }

  .ratgeber-karte h3 {
    margin: 0 0 0.6rem;
    color: var(--tb-navy-900);
  }

  .ratgeber-karte:hover h3 {
    text-decoration: underline;
  }

  .ratgeber-karte .weiter {
    display: inline-block;
    margin-top: 0.75rem;
    font-weight: 700;
    color: var(--tb-navy-700);
  }

  .ratgeber-mehr {
    margin-top: 2.5rem;
  }
</style>
